/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_ITEMS_RECORDS_META_DATA,
  LOAD_ITEMS,
  CREATE_ITEMS,
  UPDATE_ITEMS,
  DELETE_ITEMS,
  LOAD_CATEGORY,
  CREATE_CATEGORY,
  ADJUST_STOCK,
  STOCK_DETAILS,
  LOAD_PARTY_WISE_REPORT,
  LOAD_STOCK_VALUE,
  LOAD_BRAND_LIST,
  CREATE_BRAND_LIST,
  CREATE_GRADE_LIST,
  LOAD_GRADE_LIST,
} from "./constants";

import {
  loadItemsError,
  loadItems,
  loadItemsSuccess,
  createItemListSuccess,
  createItemListError,
  updateItemListSuccess,
  updateItemListError,
  deleteItemListSuccess,
  deleteItemListError,
  loadItemsRecordsMetaDataError,
  loadItemsRecordsMetaDataSuccess,
  loadCategory,
  loadCategorySuccess,
  loadCategoryError,
  createCategoryListSuccess,
  createCategoryListError,
  adjustStockListSuccess,
  adjustStockListError,
  loadStockList,
  loadStockListSuccess,
  loadStockListError,
  loadPartyWiseReport,
  loadPartyWiseReportSuccess,
  loadPartyWiseReportError,
  loadStockValueList,
  loadStockValueListSuccess,
  loadStockValueListError,
  loadBrandList,
  loadBrandListSuccess,
  // createBrandList,
  createBrandListSuccess,
  createBrandListError,
  createGradeListSuccess,
  createGradeListError,
  loadGradeList,
  loadGradeListSuccess,
  loadGradeListError,
  loadBrandListError,
} from "./actions";

import {
  loadItemsDetails,
  createItemDetails,
  updateItemDetails,
  deleteItemDetails,
  loadRecordsMetaData,
  loadCategoryDetails,
  createCategoryDetails,
  adjustStockDetails,
  loadStockDetails,
  loadPartyWiseDetails,
  loadStockValueDetails,
  loadBrandDetails,
  createBrandDetails,
  createGradeDetails,
  loadGradeDetails,
} from "./remotes";

function* loadItemsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_ITEMS),
    });

    const { explicitLoad } = load;
    const { itemList } = explicitLoad || {};
    yield put(loadItems(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadItemsDetails, itemList);

        if (result) {
          yield put(loadItemsSuccess(result));
        }
      } catch (error) {
        yield put(
          loadItemsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadBrandListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_BRAND_LIST),
    });

    const { explicitLoad } = load;
    const { itemList } = explicitLoad || {};
    yield put(loadBrandList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadBrandDetails, itemList);

        if (result) {
          yield put(loadBrandListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadBrandListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadGradeListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_GRADE_LIST),
    });

    const { explicitLoad } = load;
    const { gradeList } = explicitLoad || {};
    yield put(loadGradeList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadGradeDetails, gradeList);

        if (result) {
          yield put(loadGradeListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadGradeListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createItemsSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_ITEMS),
    });

    const { itemList } = create || {};

    if (create) {
      try {
        const result = yield call(createItemDetails, itemList);
        if (result) {
          yield put(createItemListSuccess(result.data));
        }
      } catch (error) {
        yield put(
          createItemListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* loadCategorySaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_CATEGORY),
    });
    const { explicitLoad } = load;
    const { categoryList } = explicitLoad || {};
    yield put(loadCategory(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadCategoryDetails, categoryList);

        if (result) {
          yield put(loadCategorySuccess(result));
        }
      } catch (error) {
        yield put(
          loadCategoryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createCategorySaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_CATEGORY),
    });
    const { categoryList } = create || {};

    if (create) {
      try {
        const result = yield call(createCategoryDetails, categoryList);
        if (result) {
          yield put(createCategoryListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createCategoryListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createGradeDetailsSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_GRADE_LIST),
    });
    const { gradeList } = create || {};

    if (create) {
      try {
        const result = yield call(createGradeDetails, gradeList);
        if (result) {
          yield put(createGradeListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createGradeListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* createBrandListSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_BRAND_LIST),
    });
    const { brandList } = create || {};

    if (create) {
      try {
        const result = yield call(createBrandDetails, brandList);
        if (result) {
          yield put(createBrandListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createBrandListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* adjustStockSaga() {
  while (true) {
    const { create } = yield race({
      create: take(ADJUST_STOCK),
    });
    const { stockList } = create || {};

    if (create) {
      try {
        const result = yield call(adjustStockDetails, stockList);
        if (result) {
          yield put(adjustStockListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          adjustStockListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* updateItemsSaga() {
  while (true) {
    const { update } = yield race({
      update: take(UPDATE_ITEMS),
    });
    const { itemList } = update || {};

    if (update) {
      try {
        const result = yield call(updateItemDetails, itemList);
        if (result) {
          yield put(updateItemListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          updateItemListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* deleteItemsSaga() {
  while (true) {
    const { create } = yield race({
      create: take(DELETE_ITEMS),
    });
    const { itemList } = create || {};

    if (create) {
      try {
        const result = yield call(deleteItemDetails, itemList);
        if (result) {
          yield put(deleteItemListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          deleteItemListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadStockDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(STOCK_DETAILS),
    });

    const { explicitLoad } = load;
    const { stockDetails } = explicitLoad || {};
    yield put(loadStockList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadStockDetails, stockDetails);

        if (result) {
          yield put(loadStockListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadStockListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadStockValueDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_STOCK_VALUE),
    });

    const { explicitLoad } = load;
    const { stockDetails } = explicitLoad || {};
    yield put(loadStockValueList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadStockValueDetails, stockDetails);

        if (result) {
          yield put(loadStockValueListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadStockValueListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartyWiseSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PARTY_WISE_REPORT),
    });

    const { explicitLoad } = load;
    const { partyList } = explicitLoad || {};
    yield put(loadPartyWiseReport(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPartyWiseDetails, partyList);

        if (result) {
          yield put(loadPartyWiseReportSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPartyWiseReportError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadItemRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_ITEMS_RECORDS_META_DATA),
    });

    try {
      // const gstType = yield call(loadRecordsMetaData, "getgsttype", "post");
      const unit = yield call(loadRecordsMetaData, "getmeasuringunits", "post");
      const gstPercentage = yield call(loadRecordsMetaData, "getgst", "post");
      const itcApplicable = yield call(loadRecordsMetaData, "getitcapplicable", "post");

      let recordsMetaData = {
        
        gstPercentageOptions:
          (gstPercentage &&
            gstPercentage &&
            gstPercentage.length > 0 &&
            gstPercentage.map((c) =>
              Object.assign(
                {},
                {
                  label: c.gstpercentageName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        unitOptions:
          (unit &&
            unit &&
            unit.length > 0 &&
            unit.map((c) =>
              Object.assign(
                {},
                {
                  label: c.measuringunitName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        itcOptions:
          (itcApplicable &&
            itcApplicable &&
            itcApplicable.length > 0 &&
            itcApplicable.map((c) =>
              Object.assign(
                {},
                {
                  label: c.itcName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
      };

      yield put(loadItemsRecordsMetaDataSuccess(recordsMetaData));
    } catch (error) {
      yield put(
        loadItemsRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadItemsSaga(),
    loadBrandListSaga(),
    deleteItemsSaga(),
    loadCategorySaga(),
    createCategorySaga(),
    updateItemsSaga(),
    createItemsSaga(),
    loadStockDetailsSaga(),
    loadPartyWiseSaga(),
    adjustStockSaga(),
    createBrandListSaga(),
    createGradeDetailsSaga(),
    loadGradeListSaga(),
    loadStockValueDetailsSaga(),
    loadItemRecordsMetaDataSaga(),
  ]);
}
